import { openBlock as f, createElementBlock as m, renderSlot as w, defineComponent as L, computed as A, normalizeClass as h, useAttrs as B, createElementVNode as v, ref as $, onMounted as H, watch as q, nextTick as S, onBeforeUnmount as U, createCommentVNode as j, createBlock as D, Teleport as V, normalizeStyle as I, onUnmounted as Q, unref as M, useId as G, createTextVNode as F, toDisplayString as R, resolveComponent as K, withCtx as J, Fragment as W, renderList as X } from "vue";
const Y = {
  name: "TContainer"
}, P = (e, r) => {
  const o = e.__vccOpts || e;
  for (const [s, t] of r)
    o[s] = t;
  return o;
}, Z = { class: "t-container" };
function ee(e, r, o, s, t, n) {
  return f(), m("div", Z, [
    w(e.$slots, "default")
  ]);
}
const te = /* @__PURE__ */ P(Y, [["render", ee]]), oe = /* @__PURE__ */ L({
  __name: "TText",
  props: {
    center: { type: [Boolean, String] }
  },
  emits: ["click"],
  setup(e, { emit: r }) {
    const o = e, s = r, t = A(() => {
      const n = [];
      return Object.keys(o).forEach((a) => {
        o[a] && n.push("t-text--" + a);
      }), n;
    });
    return (n, a) => (f(), m("div", {
      onClick: a[0] || (a[0] = (d) => s("click", d)),
      class: h(["t-text", t.value])
    }, [
      w(n.$slots, "default")
    ], 2));
  }
}), ne = { class: "t-header--bg" }, se = { class: "t-header--top-offset" }, ae = /* @__PURE__ */ L({
  __name: "THeader",
  setup(e) {
    const r = B(), o = A(() => {
      const s = [];
      return Object.keys(r).forEach((t) => {
        r[t] !== void 0 && s.push("t-header--" + t);
      }), s;
    });
    return (s, t) => (f(), m("header", {
      class: h(["t-header", o.value])
    }, [
      v("div", ne, [
        w(s.$slots, "default")
      ]),
      v("div", se, [
        w(s.$slots, "content")
      ])
    ], 2));
  }
}), le = /* @__PURE__ */ L({
  __name: "TCard",
  emits: ["click"],
  setup(e, { emit: r }) {
    const o = B(), s = r, t = A(() => {
      const n = [];
      return Object.keys(o).forEach((a) => {
        o[a] !== void 0 && n.push("t-card--" + a);
      }), n;
    });
    return (n, a) => (f(), m("div", {
      onClick: a[0] || (a[0] = (d) => s("click", d)),
      class: h(["t-card", t.value])
    }, [
      w(n.$slots, "default")
    ], 2));
  }
}), ie = /* @__PURE__ */ L({
  __name: "TContent",
  setup(e) {
    const r = B(), o = A(() => {
      const s = [];
      return Object.keys(r).forEach((t) => {
        r[t] !== void 0 && s.push("t-content--" + t);
      }), s;
    });
    return (s, t) => (f(), m("div", {
      class: h(["t-content", o.value])
    }, [
      w(s.$slots, "default")
    ], 2));
  }
}), ce = ["innerHTML"], re = ["innerHTML"], de = /* @__PURE__ */ L({
  __name: "TTooltip",
  props: {
    show: { type: Boolean },
    disabled: { type: Boolean },
    text: {},
    detached: { type: Boolean }
  },
  emits: ["off", "body-off"],
  setup(e, { emit: r }) {
    const o = $(null), s = $(null), t = $(null), n = $(null), a = $(null), d = $("t-bc"), u = $(null), x = $(!1);
    let k = -1;
    const E = B(), p = r;
    H(() => {
      l();
    }), q(
      () => e.detached,
      (i) => {
        i ? S(() => {
          l();
        }) : (t.value && t.value.style.removeProperty("display"), c());
      }
    ), q(
      () => e.disabled,
      (i) => {
        e.detached && !i && S(() => l());
      }
    ), q(
      () => e.text,
      (i) => {
        e.detached && !i && S(() => l());
      }
    ), q(
      () => e.show,
      (i) => {
        i ? (document.removeEventListener("click", s.value), s.value = function() {
          e.show && (document.removeEventListener("click", s.value), p("body-off"));
        }, setTimeout(() => {
          document.addEventListener("click", s.value);
        }, 100), C()) : y(), S(() => {
          b(i);
        });
      }
    ), U(() => {
      c();
    });
    const T = A(() => {
      const i = [];
      return Object.keys(E).forEach((g) => {
        if (E[g] !== void 0)
          switch (i.push("t-tooltip--" + g), g) {
            case "tc":
              d.value = "t-bc";
              break;
            case "bc":
              d.value = "t-tc";
          }
      }), d.value === "t-bc" && i.push("t-tooltip--tc"), i.toString().replace(/,/g, " ");
    });
    function l() {
      e.disabled || !e.detached || (e.show || y(), document.addEventListener("scroll", z, { capture: !0, passive: !0 }), window.addEventListener("resize", z, { capture: !0, passive: !0 }), b(e.show));
    }
    function c() {
      u.value && C(), document.removeEventListener("scroll", z, { capture: !0 }), window.removeEventListener("resize", z, { capture: !0 });
    }
    function b(i) {
      if (!(!e.detached || e.disabled || !a.value))
        if (i) {
          t.value.style.display = "block";
          const g = n.value.getBoundingClientRect();
          t.value.style.display = "none", a.value.style.top = `${Math.ceil(g.y)}px`, a.value.style.left = `${Math.ceil(g.x)}px`, a.value.style.width = `${Math.ceil(g.width)}px`, a.value.style.display = "block";
        } else
          a.value.style.display = "none";
    }
    function y() {
      o.value.addEventListener("mouseover", _), o.value.addEventListener("mouseleave", O);
    }
    function C() {
      o.value.removeEventListener("mouseover", _), o.value.removeEventListener("mouseleave", O);
    }
    function _() {
      b(!x.value);
    }
    function O() {
      b(!1);
    }
    function z() {
      x.value = !0, b(!1), clearTimeout(k), k = window.setTimeout(() => {
        var g;
        x.value = !1;
        const i = !!(e.show || (g = o.value) != null && g.matches(":hover"));
        b(i), clearTimeout(k);
      }, 180);
    }
    return u.value = document.querySelector("#detached-tooltips"), u.value || (u.value = document.createElement("div"), u.value.id = "detached-tooltips", document.body.appendChild(u.value)), (i, g) => (f(), m("div", {
      ref_key: "tRoot",
      ref: o,
      class: h(["t-tooltip-wrap", [{ "t-show": i.show }, T.value, { "is-detached": i.detached }]])
    }, [
      w(i.$slots, "default"),
      i.disabled ? j("", !0) : (f(), m("div", {
        key: 0,
        ref_key: "tooltip",
        ref: t,
        class: "tooltip-inner"
      }, [
        i.text ? (f(), m("div", {
          key: 0,
          ref_key: "tContent",
          ref: n,
          class: h(["t-tooltip", d.value]),
          onClick: g[0] || (g[0] = (N) => p("off")),
          innerHTML: i.text
        }, null, 10, ce)) : (f(), m("div", {
          key: 1,
          ref_key: "tContent",
          ref: n,
          class: h(["t-tooltip", d.value]),
          onClick: g[1] || (g[1] = (N) => p("off"))
        }, [
          w(i.$slots, "text")
        ], 2))
      ], 512)),
      (f(), D(V, {
        to: "#detached-tooltips",
        disabled: !i.detached
      }, [
        i.text ? (f(), m("div", {
          key: 0,
          ref_key: "tContentClone",
          ref: a,
          class: h(["t-tooltip", d.value]),
          onClick: g[2] || (g[2] = (N) => p("off")),
          innerHTML: i.text,
          style: I(!i.detached || i.disabled ? "display: none" : "")
        }, null, 14, re)) : (f(), m("div", {
          key: 1,
          ref_key: "tContentClone",
          ref: a,
          class: h(["t-tooltip", d.value]),
          onClick: g[3] || (g[3] = (N) => p("off")),
          style: I(!i.detached || i.disabled ? "display: none" : "")
        }, [
          w(i.$slots, "text")
        ], 6))
      ], 8, ["disabled"]))
    ], 2));
  }
});
function ue(e, r, o = !0, ...s) {
  let t = 0;
  return function(n) {
    const a = n, d = function() {
      t = 0, o || e.apply(a, s);
    }, u = o && !t;
    window.clearTimeout(t), t = window.setTimeout(d, r), u && e.apply(a, s);
  };
}
const fe = ["disabled", "data-qe-id"], ve = {
  key: 0,
  class: "t-button-pa"
}, me = /* @__PURE__ */ L({
  __name: "TButton",
  props: {
    color: String,
    size: String,
    disabled: {
      type: Boolean,
      default: !1
    },
    inactive: {
      type: Boolean,
      default: !1
    },
    progress: {
      type: Boolean,
      default: !1
    },
    complementary: {
      type: Boolean,
      default: !1
    },
    dataQeId: {
      type: String,
      default: "button"
    }
  },
  emits: ["click"],
  setup(e, { emit: r }) {
    const o = B(), s = e, t = r;
    let n;
    const a = () => {
      const d = [];
      return Object.keys(o).forEach((u) => {
        o[u] !== void 0 && d.push(u);
      }), s.complementary !== !1 && d.push("complementary"), d.join(" ");
    };
    return H(() => {
      n = ue(function() {
        !s.inactive && !s.progress && t("click");
      }, 500);
    }), Q(() => {
      n = () => {
      };
    }), (d, u) => (f(), m("button", {
      class: h(["t-button", [a(), e.color, e.size, e.disabled || e.inactive ? "inactive" : "", e.progress ? "inactive progress" : ""]]),
      disabled: e.disabled,
      onClick: u[0] || (u[0] = //@ts-ignore
      (...x) => M(n) && M(n)(...x)),
      "data-qe-id": e.dataQeId
    }, [
      v("span", null, [
        w(d.$slots, "default")
      ]),
      e.progress ? (f(), m("div", ve, u[1] || (u[1] = [
        v("div", { class: "t-button-pa--bounce1" }, null, -1),
        v("div", { class: "t-button-pa--bounce2" }, null, -1),
        v("div", { class: "t-button-pa--bounce3" }, null, -1)
      ]))) : j("", !0)
    ], 10, fe));
  }
}), pe = { class: "t-toggle-box" }, ge = ["data-qe-id", "aria-expanded", "aria-controls"], he = ["id"], be = { class: "body-in-border" }, ye = /* @__PURE__ */ L({
  __name: "TToggleBox",
  props: {
    title: String,
    qeId: String,
    open: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["toggle"],
  setup(e, { emit: r }) {
    const o = e, s = r, t = G(), n = $(!1), a = $(null), d = $(null), u = $(0);
    H(() => {
      var p;
      o.open ? E() : (p = a.value) == null || p.setAttribute("inert", "");
    });
    const x = () => {
      s("toggle", E());
    };
    function k(p) {
      (p.key === "Enter" || p.key === " ") && (p.preventDefault(), s("toggle", E()));
    }
    const E = () => {
      var p, T, l, c, b;
      return n.value ? ((c = a.value) == null || c.setAttribute("style", `max-height: ${u.value + 2}px;`), (b = a.value) == null || b.setAttribute("inert", ""), setTimeout(() => {
        var y;
        n.value = !n.value, (y = a.value) == null || y.setAttribute("style", "max-height: 0;");
      }, 100), !n.value) : (n.value = !n.value, u.value = n.value ? ((p = d.value) == null ? void 0 : p.offsetHeight) ?? 0 : 0, (T = a.value) == null || T.setAttribute("style", `max-height: ${u.value + 2}px;`), (l = a.value) == null || l.removeAttribute("inert"), setTimeout(() => {
        var y;
        (y = a.value) == null || y.setAttribute("style", "max-height: inherit;");
      }, 600), n.value);
    };
    return (p, T) => (f(), m("div", pe, [
      v("header", null, [
        v("h3", {
          class: h(["headline", n.value ? "clicked" : ""]),
          onClick: x,
          "data-qe-id": e.qeId,
          role: "button",
          tabindex: "0",
          "aria-expanded": n.value,
          "aria-controls": M(t),
          onKeydown: T[0] || (T[0] = (l) => k(l))
        }, [
          F(R(e.title) + " ", 1),
          T[1] || (T[1] = v("i", { class: "icf-arrowBottom" }, null, -1))
        ], 42, ge)
      ]),
      v("div", {
        ref_key: "body",
        ref: a,
        id: M(t),
        class: h(["body", n.value ? "show" : ""])
      }, [
        v("div", {
          ref_key: "bodyIn",
          ref: d,
          class: "body-in"
        }, [
          v("div", be, [
            w(p.$slots, "default", {}, void 0, !0)
          ]),
          w(p.$slots, "bottom", {}, void 0, !0)
        ], 512),
        T[2] || (T[2] = v("div", { class: "bottom" }, null, -1))
      ], 10, he)
    ]));
  }
}), ke = /* @__PURE__ */ P(ye, [["__scopeId", "data-v-9de56bff"]]), Te = ["innerHTML"], $e = /* @__PURE__ */ L({
  __name: "TCollapsibleList",
  props: {
    htmlText: String,
    clickTag: {
      type: String,
      required: !0
    }
  },
  emits: ["action"],
  setup(e, { emit: r }) {
    const o = e, s = G(), t = $(null), n = r, a = () => {
      const l = t.value;
      S(() => {
        let c;
        Array.from(t.value.children).forEach((b) => {
          var y;
          b.tagName === ((y = o.clickTag) == null ? void 0 : y.toUpperCase()) ? (l.appendChild(b), c = void 0, c = document.createElement("div"), c.className = "collapsible-content", l.appendChild(c)) : c == null || c.appendChild(b);
        });
      }), S(() => {
        const c = t.value.querySelectorAll(o.clickTag), b = t.value.querySelectorAll(".collapsible-content");
        let y = 0;
        Array.from(c).forEach((C) => {
          C.setAttribute("data-qe-id", `faq-headline-${++y}`), d(C), u(C), x(C, `${s}-${y}`);
        }), y = 0, Array.from(b).forEach((C) => {
          C.setAttribute("data-qe-id", `faq-content-${++y}`), C.addEventListener("click", (_) => {
            n("action", _);
          }), C.setAttribute("id", `${s}-${y}`), C.setAttribute("inert", "");
        });
      });
    }, d = (l) => {
      l.classList.add("headline");
      const c = document.createElement("i");
      c.classList.add("icf-arrowBottom"), l.appendChild(c);
    }, u = (l) => {
      l.addEventListener("click", E), l.addEventListener("keydown", k);
    };
    function x(l, c) {
      l.setAttribute("role", "button"), l.setAttribute("tabindex", "0"), l.setAttribute("aria-expanded", "false"), l.setAttribute("aria-controls", c);
    }
    function k(l) {
      (l.key === "Enter" || l.key === " ") && (E(l), l.preventDefault());
    }
    function E(l) {
      const c = l.target;
      c.classList.contains("open") ? T(c) : p(c);
    }
    function p(l) {
      var c;
      l.classList.add("open"), l.setAttribute("aria-expanded", "true"), (c = l.nextSibling) == null || c.removeAttribute("inert");
    }
    function T(l) {
      var c;
      l.classList.remove("open"), l.setAttribute("aria-expanded", "false"), (c = l.nextSibling) == null || c.setAttribute("inert", "");
    }
    return H(a), q(() => o.htmlText, a), (l, c) => {
      const b = K("t-text");
      return f(), D(b, null, {
        default: J(() => [
          v("div", {
            class: "t-collapsible-list",
            ref_key: "textNode",
            ref: t,
            innerHTML: e.htmlText
          }, null, 8, Te)
        ]),
        _: 1
      });
    };
  }
}), xe = {
  key: 1,
  class: "t-progress--horizontal"
}, Ce = /* @__PURE__ */ L({
  __name: "TProgress",
  props: {
    horizontal: {
      type: Boolean,
      default: !1
      // activate horizontal version
    },
    absolute: {
      type: Boolean,
      default: !1
    },
    fixed: {
      type: Boolean,
      default: !1
    },
    // configure t-shirt sizes s, m, l
    size: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const r = B(), o = e, s = A(() => {
      const t = [];
      return Object.keys(r).forEach((n) => {
        r[n] !== void 0 && t.push("t-progress--" + n);
      }), o.size && t.push("t-progress--" + o.size), o.color && t.push("t-progress--" + o.color), o.absolute !== !1 && t.push("t-progress--absolute"), o.fixed !== !1 && t.push("t-progress--fixed"), t.join(" ");
    });
    return (t, n) => (f(), m("div", {
      class: h(["t-progress", `${s.value}`]),
      "data-qe-id": "progress"
    }, [
      e.horizontal === !1 ? (f(), m("div", {
        key: 0,
        class: h(["circle", e.size])
      }, null, 2)) : (f(), m("div", xe, n[0] || (n[0] = [
        v("div", { class: "t-progress--horizontal--bounce1" }, null, -1),
        v("div", { class: "t-progress--horizontal--bounce2" }, null, -1),
        v("div", { class: "t-progress--horizontal--bounce3" }, null, -1)
      ])))
    ], 2));
  }
}), we = ["data-gametype", "data-qe-id"], Le = /* @__PURE__ */ L({
  __name: "TGameLogo",
  props: {
    size: String,
    gametype: String
  },
  setup(e) {
    const r = B(), o = e, s = A(() => {
      const t = [];
      return o.size ? t.push(o.size === "s" ? "gameLogo60x40" : "gamelogo106x74") : Object.keys(r).forEach((n) => {
        r[n] !== void 0 && (n === "s" ? t.push("gameLogo60x40") : n === "m" && t.push("gamelogo106x74"));
      }), t.indexOf("gameLogo60x40") === -1 && t.indexOf("gamelogo106x74") === -1 && t.push("gamelogo106x74"), t.push("game_" + o.gametype), process.env.NODE_ENV === "development" && t.push("t-game-logo--dev"), t;
    });
    return (t, n) => (f(), m("div", {
      onClick: n[0] || (n[0] = (a) => t.$emit("click", a)),
      class: h(s.value),
      "data-gametype": e.gametype,
      "data-qe-id": `game-logo-${e.gametype}`
    }, null, 10, we));
  }
}), Ee = {
  class: "t-pagination",
  "data-qe-id": "pagination"
}, Ae = ["onClick", "data-qe-id"], Be = /* @__PURE__ */ L({
  __name: "TPagination",
  props: {
    items: { type: Number, default: 0 },
    chunk: { type: Number, default: 0 },
    activePage: { type: Number, default: 0 }
  },
  emits: ["click"],
  setup(e, { emit: r }) {
    const o = e, s = r, t = A(() => Array.from({ length: Math.ceil(o.items / o.chunk) }, (u, x) => ({
      idx: x
    }))), n = () => {
      o.activePage <= 0 || s("click", o.activePage - 1);
    }, a = (u) => {
      s("click", u);
    }, d = () => {
      o.activePage >= t.value.length - 1 || s("click", o.activePage + 1);
    };
    return (u, x) => (f(), m("div", Ee, [
      v("div", {
        class: h([e.activePage <= 0 ? "t-pagination-inactive" : "", "t-pagination-btn icf-arrowLeft"]),
        onClick: n,
        "data-qe-id": "prev"
      }, null, 2),
      v("ul", null, [
        (f(!0), m(W, null, X(t.value, (k) => (f(), m("li", {
          key: k.idx
        }, [
          v("div", {
            onClick: (E) => a(k.idx),
            class: h(["button", k.idx === e.activePage ? "t-pagination-active" : ""]),
            "data-qe-id": `num-${k.idx}`
          }, [
            v("span", null, R(k.idx + 1), 1)
          ], 10, Ae)
        ]))), 128))
      ]),
      v("div", {
        class: h([e.activePage >= t.value.length - 1 ? "t-pagination-inactive" : "", "t-pagination-btn icf-arrowRight"]),
        onClick: d,
        "data-qe-id": "next"
      }, null, 2)
    ]));
  }
}), Se = /* @__PURE__ */ P(Be, [["__scopeId", "data-v-397939f1"]]);
function _e(e) {
  e.component("t-container", te), e.component("t-text", oe), e.component("t-header", ae), e.component("t-card", le), e.component("t-content", ie), e.component("t-tooltip", de), e.component("t-button", me), e.component("t-toggle-box", ke), e.component("t-collapsible-list", $e), e.component("t-progress", Ce), e.component("t-game-logo", Le), e.component("t-pagination", Se);
}
export {
  me as TButton,
  le as TCard,
  $e as TCollapsibleList,
  te as TContainer,
  ie as TContent,
  Le as TGameLogo,
  ae as THeader,
  Se as TPagination,
  Ce as TProgress,
  oe as TText,
  ke as TToggleBox,
  de as TTooltip,
  _e as default,
  _e as loadTComponents
};
